import type { ReactNode } from "react";

/** Shared `<svg>` wrapper for the app's icon set (all simple strokes, no emoji, no fill) — every icon-only button uses one of these instead of the raw wrapper attributes repeated per file. */
export function Icon({
  children,
  strokeLinecap = "round",
  strokeLinejoin = "round",
}: {
  children: ReactNode;
  strokeLinecap?: "round" | "butt" | "square";
  strokeLinejoin?: "round" | "miter" | "bevel";
}) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap={strokeLinecap}
      strokeLinejoin={strokeLinejoin}
    >
      {children}
    </svg>
  );
}
